import { getServer } from "@translations/next";
import Wellness65Container from "@containers/Wellness65Container";
import LocomotiveProvider from "@providers/LocomotiveProvider";
import WrapperProvider from "@providers/WrapperProvider";
import _ from "lodash";
import Layout from "@components/Layout";
import StrapiService from "@services/StrapiService";
import FooterService from "@services/FooterService";

export default function View(props: any) {
  return (
    <WrapperProvider
      pageContext={{
        ...props,
      }}
    >
      <Layout>
        <LocomotiveProvider
          options={{
            smooth: true,
            getSpeed: true,
            getDirection: true,
            reloadOnContextChange: true,
            mobile: {
              smooth: true,
            },
            tablet: {
              smooth: true,
            },
          }}
        >
          <Wellness65Container />
        </LocomotiveProvider>
      </Layout>
    </WrapperProvider>
  );
}

// export { getServerSideProps };
export const getServerSideProps = getServer(async ({ params }: any) => {
  const locale: any = _.get(params, "locale", "en");
  StrapiService.set("id", "hotel65-facilities-services-page");
  const res = await StrapiService.find({ populate: "deep", locale });
  StrapiService.set("id", "hotel65-stay-connected");
  const resPage = await StrapiService.find({
    populate: "deep",
    locale,
  });
  const footerData = await FooterService.fetchByHotel("amanaki-boutique-saigon", locale);
  return {
    hotel: "amanaki-boutique-saigon",
    pageData: {
      ..._.get(res, "data", {}),
      stayConnected: _.get(resPage, "data", {}),
    },
    footerData,
  };
});
